/**
 * @typedef {Object} APIEndpoints
 * @property {string} REACT_APP_LOGIN_END_POINT - Login endpoint for admin users.
 * @property {string} REACT_APP_CHANGE_PASSWORD_END_POINT - Endpoint to change an admin's password.
 * * // Organizer Management Endpoints
 * @property {string} REACT_APP_CREATE_ORGANIZER_END_POINT - Endpoint for creating a new organizer.
 * @property {string} REACT_APP_UPDATE_ORGANIZER_END_POINT - Endpoint for updating an existing organizer.
 * @property {string} REACT_APP_DELETE_ORGANIZER_END_POINT - Endpoint for deleting an organizer.
 * @property {string} REACT_APP_GET_ORGANIZER_LIST_END_POINT - Endpoint to fetch the complete list of organizers.
 * @property {string} REACT_APP_GET_ACTIVE_ORGANIZER_LIST_END_POINT - Endpoint to fetch a list of only active organizers.
 * @property {string} REACT_APP_GET_ORGANIZER_BY_ID_END_POINT - Endpoint to get a single organizer by ID.
 * @property {string} REACT_APP_ASSIGN_ORGANIZER_END_POINT - Endpoint to assign organizers (e.g., to an event).
 * @property {string} REACT_APP_GET_ORGANIZER_EVENTS_BY_ID_END_POINT - Endpoint to get events associated with a specific organizer ID.
 * * // Event Management Endpoints
 * @property {string} REACT_APP_CREATE_EVENTS_END_POINT - Endpoint for creating a new event.
 * @property {string} REACT_APP_UPDATE_EVENTS_END_POINT - Endpoint for updating an existing event.
 * @property {string} REACT_APP_UPDATE_DESTINATION_URL_END_POINT - Endpoint for updating the event's destination URL.
 * @property {string} REACT_APP_GET_ALL_EVENTS_END_POINT - Endpoint to fetch all events.
 * @property {string} REACT_APP_GET_EVENT_BY_ID_END_POINT - Endpoint to get a single event by ID.
 * @property {string} REACT_APP_DELETE_EVENT_BY_ID_END_POINT - Endpoint for deleting an event by ID.
 * @property {string} REACT_APP_GET_ALL_RECENT_EVENTS_END_POINT - Endpoint to fetch a list of all recent events.
 * * // Analytics/Tracking Endpoints
 * @property {string} REACT_APP_TRACK_URL_END_POINT - Endpoint prefix for tracking URL clicks.
 * @property {string} REACT_APP_GET_CLICK_COUNT_BY_ID_END_POINT - Endpoint to get the total click count for a specific event ID.
 * @property {string} REACT_APP_GET_CLICK_ANALYTICS_BY_ID_END_POINT - Endpoint to get detailed click analytics by event ID.
 * @property {string} REACT_APP_GET_CLICK_TIMELINE_ANALYTICS_BY_ID_END_POINT - Endpoint to get click timeline data for an event ID.
 * * // CFA Endpoints
 * @property {string} REACT_APP_CFA_GET_CAPTCURE_DATA_END_POINT - Endpoint to retrieve captured feedback data.
 * * // UNITUS/GCU Endpoints
 * @property {string} UNITE_US_GCU_GET_SCHOOL_DATA_END_POINT - Endpoint to retrieve school data for the UNITE_US_GCU project.
 * @property {string} UNITE_US_GCU_SET_SCHOOL_DATA_END_POINT - Endpoint to create school data for the UNITE_US_GCU project.
 * @property {string} UNITE_US_GCU_DELETE_SCHOOL_DATA_END_POINT - Endpoint to delete a school's data for the UNITE_US_GCU project.
 * @property {string} UNITE_US_GCU_UPDATE_SCHOOL_DATA_END_POINT - Endpoint to update a school's data for the UNITE_US_GCU project.
 */

const API_ENDPOINTS = {
    REACT_APP_LOGIN_END_POINT: 'sparkMotion-auth/login',
    REACT_APP_CHANGE_PASSWORD_END_POINT: 'sparkMotion-auth/admin-change-password',
    REACT_APP_VALIDATE_TOKEN_END_POINT: 'sparkMotion-auth/validate',


    // Organizers Endpoints
    REACT_APP_CREATE_ORGANIZER_END_POINT: 'sparkMotion-organizer/create-organizer',
    REACT_APP_UPDATE_ORGANIZER_END_POINT: 'sparkMotion-organizer/update-organizer',
    REACT_APP_DELETE_ORGANIZER_END_POINT: 'sparkMotion-organizer/delete-organizer',
    REACT_APP_GET_ORGANIZER_LIST_END_POINT: 'sparkMotion-organizer/get-organizers-list',
    REACT_APP_GET_ACTIVE_ORGANIZER_LIST_END_POINT: 'sparkMotion-organizer/get-active-organizers-list',
    REACT_APP_GET_ORGANIZER_BY_ID_END_POINT: 'sparkMotion-organizer/get-organizer',
    REACT_APP_ASSIGN_ORGANIZER_END_POINT: 'sparkMotion-organizer/assign-organizers',
    REACT_APP_GET_ORGANIZER_EVENTS_BY_ID_END_POINT: 'sparkMotion-events/get-organizer-events',

    // Events Endpoints
    REACT_APP_CREATE_EVENTS_END_POINT: 'sparkMotion-events/create-event',
    REACT_APP_UPDATE_EVENTS_END_POINT: 'sparkMotion-events/update-event',
    REACT_APP_UPDATE_DESTINATION_URL_END_POINT: 'sparkMotion-events/update-destination-url',
    REACT_APP_GET_ALL_EVENTS_END_POINT: 'sparkMotion-events/get-all-events',
    REACT_APP_GET_EVENT_BY_ID_END_POINT: 'sparkMotion-events/get-eventsById',
    REACT_APP_DELETE_EVENT_BY_ID_END_POINT: 'sparkMotion-events/delete-event',
    REACT_APP_GET_ALL_RECENT_EVENTS_END_POINT: 'sparkMotion-events/get-all-recent-events',


    // Analytics Endpoints
    REACT_APP_TRACK_URL_END_POINT: 'sma/e/',
    REACT_APP_GET_CLICK_COUNT_BY_ID_END_POINT: 'sma/getEventClickCount',
    REACT_APP_GET_CLICK_ANALYTICS_BY_ID_END_POINT: 'sma/getClickAnalytics',
    REACT_APP_GET_CLICK_TIMELINE_ANALYTICS_BY_ID_END_POINT: 'sma/getClickTimeline',
    REACT_APP_GET_FEEDBACK_FORM_ANALYTICS_BY_ID_END_POINT: 'sma/getFeedbackFormTimeline',

    //CFA
    REACT_APP_CFA_GET_CAPTCURE_DATA_END_POINT: "CFA/GetFeedbackData",

    //UNITUS
    UNITE_US_GCU_GET_SCHOOL_DATA_END_POINT: "UNITE_US_GCU/getSchoolsData",
    UNITE_US_GCU_SET_SCHOOL_DATA_END_POINT: "UNITE_US_GCU/setSchoolsData",
    UNITE_US_GCU_DELETE_SCHOOL_DATA_END_POINT: "UNITE_US_GCU/deleteSchoolData",
    UNITE_US_GCU_UPDATE_SCHOOL_DATA_END_POINT: "UNITE_US_GCU/updateSchoolsData",

};

export default API_ENDPOINTS;
